export default "__VITE_ASSET__fXu0OAEL__"